<template>
  <nav class="navbar navbar-expand-lg navbar-dark bg-dark">
    <div class="container-fluid">
      <a class="navbar-brand pl-2" href="#">3C Perdas</a>
      <!-- Sidenav toggle (see demo.css) -->
      <b-navbar-nav
        tag="ul"
        class="layout-sidenav-toggle d-lg-none align-items-lg-center mr-auto"
        v-if="sidenavToggle"
      >
        <a
          class="nav-item nav-link px-0 mr-lg-4"
          href="javascript:void(0)"
          @click="toggleSidenav"
        >
          <i class="ion ion-md-menu text-large align-middle" />
        </a>
      </b-navbar-nav>

      <button
        class="navbar-toggler"
        type="button"
        data-toggle="collapse"
        data-target="#navbarsExample07"
        aria-controls="navbarsExample07"
        aria-expanded="false"
        aria-label="Toggle navigation"
      >
        <span class="navbar-toggler-icon"></span>
      </button>

      <div class="collapse navbar-collapse" id="navbarsExample07">
        <ul class="navbar-nav ml-auto">
          <li class="nav-item dropdown">
            <a
              class="nav-link dropdown-toggle"
              href="#"
              id="dropdown01"
              data-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              >Olá, {{ details ? details.name : "" }}</a
            >
            <div class="dropdown-menu" aria-labelledby="dropdown01">
              <button class="dropdown-item" @click="signOut">Sair</button>
            </div>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import { mapActions, mapState } from "vuex"
export default {
  name: "app-layout-navbar",

  props: {
    sidenavToggle: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    ...mapState("auth", ["details"]),
  },
  methods: {
    ...mapActions("auth", ["logout"]),
    signOut() {
      try {
        this.logout()
        this.$router.push("/")
      } catch (error) {
        this.$swal({ icon: "error", text: error.response.data.message })
      }
    },
    toggleSidenav() {
      this.layoutHelpers.toggleCollapsed()
    },

    getLayoutNavbarBg() {
      return this.layoutNavbarBg
    },
  },
}
</script>
